<template lang="pug">
  .fixed-challenge(ref='challenge')
    .fixed-challenge__container(:class="{'fixed':sticky, 'static':!sticky}")
      p.fixed-challenge__header Challenge Legal Entity Events
      .fixed-challenge__wrap
        comment-input.fixed-challenge__comment(@input="comment=$event" :max=2000 :cancel="cancel")
        .fixed-challenge__control
          lei-btn.fixed-challenge__button(type="cyprus" fill @click="save" :disabled="disabled" ) Save
          challenge-control-section.fixed-challenge__summary(v-if="saved && sticky")
</template>

<script>
import { mapState, mapMutations, } from 'vuex'
import { SAVE_FIELD, } from '@/store/modules/record/modules/challenge/mutations-types'
import LeiBtn from '@/components/lei-components/LeiBtn'
import CommentInput from '@/components/lei-components/inputs/CommentInput'
import IntersectionObserverMixin from '@/mixins/IntersectionObserverMixin'
import ChallengeControlSection from '@/components/challenge-components/ChallengeControlSection'



import { stopPositionFixed, } from '@/utils/helpers'

export default {
  name: 'EventsFixedChallenge',
  components: {
    LeiBtn,
    CommentInput,
    ChallengeControlSection,
  },

  mixins: [
    IntersectionObserverMixin(
      [ 'challenge', ], stopPositionFixed
    ),
  ],

  props: {
    sticky: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      comment: {
        value: '',
        valid: true,
      },
      saved: false,
      cancel: false,
    }
  },
  computed: {
    disabled () {
      return !this.comment.value || !this.comment.valid
    },
    ...mapState('record/challenge', [ 'fields', ]),
  },

  watch: {
    fields (){
      if (this.fields.length === 0){
        this.comment = {
          value: '',
          valid: true,
        }
        this.saved = false
        this.cancel = true
      }
    },
  },

  methods: {
    save () {
      const field = '/lei:LEIData/lei:LEIRecords/lei:LEIRecord/lei:Entity/lei:LegalEntityEvents/lei:LegalEntityEvent'
      let fieldFormattedForStore = {
        original_value: '',
        proposed_value: this.comment.value,
        comment: '',
        field: field,
        jsonPath: '$.entity.associatedEntity.legalEntityEvents.legalEntityEvent',
      }
      this.saveField(fieldFormattedForStore)
      this.saved = true
      this.cancel = false
      this.$message({
        type: 'success',
        message: 'Legal Entity Events challenge saved',
      })
    },
    ...mapMutations('record/challenge', {
      saveField: SAVE_FIELD,
    }),
  },
}
</script>

<style scoped lang="stylus">
@import "../../assets/styles/variables.styl"

.fixed-challenge
  &__container
    z-index 90
    padding 30px
    background-color $white-color
    border 1px solid $input-border

  .static
    margin-bottom 30px
    @media screen and (max-width: $laptop)
      margin-bottom 0

  .absolute
    position: absolute!important
    bottom 0 !important
    right 0 !important

  .fixed
    position fixed
    top 500px
    right 20px
    @media screen and (max-width: $laptop-xl)
      top auto
      bottom 75px

  &__comment
    min-width  590px
    padding 0
    @media screen and (max-width: $tablet)
      min-width 250px
      padding 0

  &__header
    font-weight 600
    margin-bottom  10px
    color $default-color-bold
    display inline-block
  &__button
    margin-top 20px
  &__tip
    display inline-block
    margin-left 10px
    color $success-color
    @media screen and (max-width: $tablet)
      margin-top 10px
      display block
  &__control
    display flex
    justify-content space-between
    @media screen and (max-width: $tablet)
      flex-direction column
    section
      margin 20px 0 0
      padding 0

  &__summary
    width auto
    min-width auto
    justify-content end
    @media screen and (max-width: $tablet)
      width 100%




</style>



// WEBPACK FOOTER //
// src/components/challenge-components/EventsFixedChallenge.vue